
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { login, logout } from '@/core/services/admin-service'
import { isAdmin } from '@/core/services/auth-service'
import { useRouter } from 'vue-router'

export default defineComponent({
  setup() {
    const state = reactive({
      username: 'admin',
      password: ''
    })

    onMounted(async () => {
      const router = useRouter()
      await router.isReady()
      if(router.currentRoute.value.name === 'administration') {
        router.push({ name: 'SnapshotList' })
      }
    })

    async function authenticateAdmin() {
      if(state.username && state.password) {
        await login(state.username, state.password)
      }
    }

    return {
      logout,
      authenticateAdmin,
      isAdmin,
      ...toRefs(state)
    }
  }
})
